module.exports = __webpack_public_path__ + "static/michelle-obama-c7689f53bc675daa3e7adebdab718191.jpg";